// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IconButton } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import { toast } from 'react-toastify';

// Internal Dependencies
import apiService from '../../../../services.js/apiService';
import Colours from '../../../../styles/colours';
import { updateModalContent as updateModalAction, toggleModal as toggleModalAction } from '../../../../actions/modal';

const TrailItemDelete = ({ toggleModal, updateModalContent, pageId, trailItemId, onRefresh, onLoading, onLoadingEnd, disabled }) => {
  const handleDeleteModal = () => {
    updateModalContent({
      title:        'Are you sure?',
      content:      'All data related to this trail item will be deleted!',
      actionButton: {
        actionText: 'Yes, Delete',
        actionType: 'danger',
        action:     async () => {
          try {
            onLoading();
            await apiService.deleteTrailItem(pageId, trailItemId);
            onRefresh();
            toast.success('Successfully deleted trail item.');
          } catch (err) {
            toast.error(err.message);
          } finally {
            onLoadingEnd();
          }
        },
      },
      cancelText:       'No',
      closeAfterAction: true,
    });
    toggleModal();
  };

  return (
    !disabled && (
      <IconButton onClick={handleDeleteModal}>
        <DeleteIcon htmlColor={Colours.Black} />
      </IconButton>
    )
  );
};

TrailItemDelete.propTypes = {
  toggleModal:        PropTypes.func.isRequired,
  updateModalContent: PropTypes.func.isRequired,
  onRefresh:          PropTypes.func.isRequired,
  pageId:             PropTypes.string.isRequired,
  trailItemId:        PropTypes.number.isRequired,
  onLoading:          PropTypes.func.isRequired,
  onLoadingEnd:       PropTypes.func.isRequired,
  disabled:           PropTypes.bool,
};

TrailItemDelete.defaultProps = {
  disabled: false,
};

export default connect(null, { toggleModal: toggleModalAction, updateModalContent: updateModalAction })(TrailItemDelete);
